<!--
 01-01-2025
 Copyright (c) 2016 Aruba. All Rights Reserved.
 -->
<nav class="navbar fixed-top navbar-light navbar-expand-md bg-light">
  <a class="navbar-toggler d-lg-none"
    data-toggle="collapse" data-target="#ap-sidenav"
    aria-controls="navbarResponsive" aria-expanded="false"
    aria-label="Toggle navigation" (click)="toogleMobileNav()">
    <fa-icon icon="bars"></fa-icon>
  </a>
  <a
    class="navbar-brand logo"
    [routerLink]="['/', currentCompany, 'security', 'managedetails']"
    (click)="collapseNavbar()">
    <span class="logo-img" #logo [class.loading]="loadingLogo">
      <fa-icon icon="spinner" [pulse]="true" *ngIf="loadingLogo"></fa-icon>
    </span>
  </a>
  <div class="nav-item d-none d-lg-block pe-0 invisible">
    <span class="navbar-version">{{ version }}</span>
  </div>
  <ng-container *ngIf="!appConfig.usabillaEnabled">
    <ng-container *ngTemplateOutlet="GuideTemplateWithoutUsabilla; context: { hideDesktop: true }"></ng-container>
  </ng-container>

  <div id="ap-pecplus" #pecplus class="sidenav" [class.opened]="isMobileNavVisible" *ngIf="openPecPlus">
    <div class="nav-item ms-0 mt-2 mb-3" display="dynamic">
      <div class="navbar-brand" id="account-menu">
        <div class="ms-1">
          <a class="font-14" (click)="togglePecPlus($event, true)">
            <svg-icon
              src="/content/images/icons/chevron-left.svg"
              [svgStyle]="{ 'width.px': '8', 'height.px': '8', 'vertical-align': 'middle!important' }"
            ></svg-icon>
            <span>{{ 'navbar.pecPlus.back' | translate }}</span>
          </a>
          <ul class="ulpecplus">
            <div class="mx-2" *ngIf="verifyAcls(acls.DOCAPOSTE_VIEW)">
              <ng-container
                *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW) && isPecPlusVisible !== 0 && !isLegalPersonDeleted"
              >
                <li class="mt-3 mb-3 nav-item">
                  <div class="d-flex justify-content-between">
                    <span class="font-14 text-email-mobile">{{
                      account
                        ? account.name + ' ' + account.lastname
                        : 'User
                      undefined'
                    }}</span>
                    <span>
                      <span *ngIf="iconUser" class="ms-3">
                        <svg-icon
                          src="/content/images/icons/user.svg"
                          [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important' }">
                        </svg-icon>
                        <svg-icon
                          src="/content/images/icons/badge.svg"
                          [svgStyle]="{
                            'width.px': '12',
                            'height.px': '12',
                            'vertical-align': 'middle!important;',
                            'margin-left': '-10px',
                            'margin-top': '5px'}"></svg-icon>
                      </span>
                      <span *ngIf="iconAlert" class="me-3">
                        <svg-icon
                          src="/content/images/icons/alert-triangle.svg"
                          [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important;' }">
                        </svg-icon>
                      </span>
                      <span *ngIf="iconError" class="me-3">
                        <svg-icon
                          src="/content/images/icons/octagon_deny1.svg"
                          [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important;' }">
                        </svg-icon>
                      </span>
                    </span>
                  </div>
                </li>
                <hr />
                <li class="mt-3 nav-item">
                  <ng-container *ngIf="isPecPlusVisible === 1">
                    <p>
                      <strong class="font-14 descMobile" [innerHTML]="'navbar.pecPlus.titleDisableMobile' | translate">
                      </strong>
                      <svg-icon
                        src="/content/images/icons/badge.svg"
                        [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'vertical-align': 'center' }"></svg-icon>
                    </p>

                    <p class="mt-2 text-start font-14 descMobile">{{ 'navbar.pecPlus.descDisable' | translate }}</p>
                    <p class="text-start font-14">
                      <a rel="noopener noreferrer" href="{{ urlGuide }}" target="_blank"
                        >{{ 'navbar.pecPlus.question' | translate }}
                        <script>
                          window.dataLayer = window.dataLayer || [];
                          dataLayer.push({ event: 'GAEvent', eventCategory: 'conferma_identita',
                            eventAction: 'click', eventLabel: 'Dropdown - Perchè farlo'});
                        </script>
                      </a>
                    </p>
                    <ng-container *ngIf="recognitionStatus === 'OK'">
                      <div class="font-14 text-start d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                        <span>
                          <div class="confirm font-12 ps-1 pe-1">
                            <div class="circleConfirm mr-1 displayInline"></div>
                            <strong> {{ 'navbar.pecPlus.confirmed' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="recognitionStatus === 'IdentificationPending'">
                      <div class="font-14 text-start d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                        <span>
                          <div class="notIdentified font-12 ps-1 pe-1">
                            <div class="circleNotIdentified mr-1 displayInline"></div>
                            <strong> {{ 'navbar.pecPlus.toBeConfirm' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                      <div class="identificationPending">
                        <svg-icon src="/content/images/icons/time-fast.svg" class="mgr5px"></svg-icon>
                        <span
                          >{{ 'navbar.pecPlus.identificationPending' | translate }}
                          {{ dvoExpireDate | date : 'DD/MM/YYYY' }}
                        </span>
                      </div>
                      <div>
                        <button class="btn-secondary-lined-xs mt-2" (click)="openReadDossier()">
                          {{ 'navbar.pecPlus.recognition' | translate }}
                        </button>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="recognitionStatus === 'TerritorioPending'">
                      <div class="font-14 text-start d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                        <span>
                          <div class="notIdentified font-12 ps-1 pe-1">
                            <div class="circleNotIdentified mr-1 displayInline"></div>
                            <strong>{{ 'navbar.pecPlus.toBeConfirm' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                      <div class="identificationPending">
                        <svg-icon src="/content/images/icons/time-fast.svg" class="mgr5px"></svg-icon>
                        <span class="text-start"
                          >{{ 'navbar.pecPlus.identificationPending' | translate }}
                          {{ territoryExpireDate | date : 'DD/MM/YYYY' }}</span>
                      </div>

                      <div>
                        <button class="btn-secondary-lined-xs mt-2" (click)="openReadDossier()">
                          {{ 'navbar.pecPlus.recognition' | translate }}
                        </button>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="recognitionStatus === 'LegalValidationFailed'">
                      <div class="font-14 text-start d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                        <span>
                          <div class="docRequired font-12 ps-1 pe-1">
                            <div class="circleDocRequired mr-1 displayInline"></div>
                           <strong> {{ 'navbar.pecPlus.missingDoc' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                     <!-- <div class="identificationPending">
                        <svg-icon src="/content/images/icons/time-fast.svg" class="mgr5px"></svg-icon>
                        <span class="text-start">{{ 'navbar.pecPlus.territorioPendingMobile' | translate }}</span>
                        <div>{{ 'navbar.pecPlus.territorioPendingMobile1' | translate }}</div>
                        <div>
                          {{ 'navbar.pecPlus.territorioPendingMobile2' | translate }}
                          {{ territoryExpireDate | date : 'DD/MM/YYYY' }}
                        </div>
                      </div>
                    -->
                      <div>
                        <button class="btn-secondary-lined-xs mt-2" (click)="openReadDossier()">
                          {{ 'navbar.pecPlus.recognition' | translate }}
                        </button>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="recognitionStatus === 'NotIdentified'">
                      <div class="font-14 text-start d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                        <span>
                          <div class="notIdentified font-12 ps-1 pe-1">
                            <div class="circleNotIdentified mr-1 displayInline"></div>
                            <strong>{{ 'navbar.pecPlus.toBeConfirm' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                      <div>
                        <button class="btn-secondary-lined-xs mt-2" (click)="openReadDossier()">
                          {{ 'navbar.pecPlus.recognition' | translate }}
                          <script>
                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({ event: 'GAEvent', eventCategory: 'conferma_identita',
                              eventAction: 'click', eventLabel: 'Dropdown - Conferma la tua identità"'});
                          </script>
                        </button>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="recognitionStatus === 'IdentificationInProgress'">
                      <div class="font-14 text-start d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                        <span>
                          <div class="checkInProgress font-12 ps-1 pe-1">
                            <div class="circleCheckInProgress mr-1 displayInline"></div>
                            <strong> {{ 'navbar.pecPlus.checkInProgress' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="recognitionStatus === 'DocumentsRequired'">
                      <div class="font-14 text-start d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                        <span>
                          <div class="docRequired font-12 ps-1 pe-1">
                            <div class="circleDocRequired mr-1 displayInline"></div>
                            <strong>{{ 'navbar.pecPlus.missingDoc' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                      <div>
                        <button class="btn-secondary-lined-xs mt-2 ms-2 me-2" (click)="openReadDossier()">
                          {{ 'navbar.pecPlus.sendMissingDoc' | translate }}
                        </button>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="!isTwoFAStatus">
                      <div class="font-14 text-start mt-4 d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.2fa' | translate }}</strong>
                        <span>
                          <div class="notIdentified font-12 ps-1 pe-1">
                            <div class="circleNotIdentified mr-1 displayInline"></div>
                            <strong> {{ 'navbar.pecPlus.disabled' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                      <div class="mb-2">
                        <button
                          (click)="openRoute()"
                          class="btn-secondary-lined-xs mt-2"
                          [routerLink]="['/', currentCompany, 'security', '2stepverification']"
                          routerLinkActive="active"
                          [routerLinkActiveOptions]="{ exact: true }">
                          {{ 'navbar.pecPlus.btn2fa' | translate }}
                          <script>
                            window.dataLayer = window.dataLayer || [];
                            dataLayer.push({ event: 'GAEvent', eventCategory: 'conferma_identita',
                              eventAction: 'click', eventLabel: 'Dropdown - Attiva verifica in 2 passaggi'});
                          </script>
                        </button>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="isTwoFAStatus">
                      <div class="font-14 text-start mt-4 mr-4 d-flex justify-content-between">
                        <strong>{{ 'navbar.pecPlus.2fa' | translate }}</strong>
                        <span>
                          <div class="confirm font-12 ps-1 pe-1">
                            <div class="circleConfirm mr-1 displayInline"></div>
                            <strong>{{ 'navbar.pecPlus.enabled' | translate }} </strong>
                          </div>
                        </span>
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="isPecPlusVisible === 2">
                    <strong class="font-16 descMobile">{{ 'navbar.pecPlus.pecplusTitle' | translate }} </strong>
                    <div
                      class="mt-2 ms-1 me-3 text-start font-14 descMobile"
                      [innerHTML]="'navbar.pecPlus.pecplusDesc' | translate">
                      Hai completato le procedure richieste
                    </div>
                    <div
                      class="ms-1 me-3 text-start font-14 descMobile"
                      [innerHTML]="'navbar.pecPlus.pecplusDesc2' | translate">
                    </div>
                    <p class="mt-3 ms-1 text-start font-14">
                      <a class="anchor question-plus" (click)="openInfoModal()">
                        {{ 'navbar.pecPlus.questionPecPlus' | translate }}</a>
                    </p>
                  </ng-container>
                </li>
              </ng-container>
              <ng-container *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW) && isLegalPersonDeleted">
                <li class="mt-3 mb-3 nav-item">
                  <div class="d-flex justify-content-between">
                    <span class="font-14 text-email-mobile">
                      {{ account? account.name + ' ' + account.lastname  : 'User undefined' }}</span>
                    <span>
                      <span *ngIf="iconUser" class="ms-3">
                        <svg-icon
                          src="/content/images/icons/user.svg"
                          [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important' }">
                        </svg-icon>
                        <svg-icon
                          src="/content/images/icons/badge.svg"
                          [svgStyle]="{
                            'width.px': '12',
                            'height.px': '12',
                            'vertical-align': 'middle!important;',
                            'margin-left': '-10px',
                            'margin-top': '5px'
                          }"
                        ></svg-icon>
                      </span>
                      <span *ngIf="iconAlert" class="me-3">
                        <svg-icon
                          src="/content/images/icons/alert-triangle.svg"
                          [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important;' }">
                        </svg-icon>
                      </span>
                      <span *ngIf="iconError" class="me-3">
                        <svg-icon
                          src="/content/images/icons/octagon_deny1.svg"
                          [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important;' }">
                        </svg-icon>
                      </span>
                    </span>
                  </div>
                </li>
                <hr />
                <li class="mt-3 nav-item">
                  <div class="ps-3">
                    <div class="font-14">
                      <strong
                        class="descMobile text-start"
                        translate="navbar.isCancelled.title"
                        translate-values="{companyName: companyName}"
                        >{{ 'contacts.bannerCancelled.title' | translate }}</strong>
                    </div>
                    <div
                      class="mt-2 font-14 descMobile text-email-mobile1 text-start"
                      translate="navbar.isCancelled.desc"
                      *ngIf="salesChannel !== 'PannelloPartner'">
                      Esegui un cambio titolare PEC
                    </div>
                    <div
                      class="mt-2 font-14 descMobile text-email-mobile1 text-start"
                      translate="navbar.isCancelled.descPec"
                      *ngIf="salesChannel === 'PannelloPartner'">
                      Esegui un cambio titolare PEC
                    </div>
                    <div class="text-start font-14">
                      <a
                        href="{{ cancelledGuideUrl }}"
                        target="_blank"
                        rel="noopener noreferrer"
                        *ngIf="salesChannel !== 'PannelloPartner'"
                      >
                        {{ 'navbar.isCancelled.anchorInfo' | translate }}
                      </a>
                    </div>
                    <div class="font-14 text-start mt-3 me-3 d-flex justify-content-between">
                      <strong>{{ 'navbar.isCancelled.owner' | translate }}</strong>
                      <span>
                        <div class="docRequired font-12 ps-1 pe-2">
                          <div class="circleDocRequired mr-1 displayInline"></div>
                          <strong>{{ 'navbar.isCancelled.deleteCompany' | translate }} </strong>
                        </div>
                      </span>
                    </div>
                  </div>
                  <div class="mt-2" *ngIf="salesChannel !== 'PannelloPartner'">
                    <button type="button" class="btn-secondary-lined-xs mt-2 ms-2 me-2" (click)="openCusermerArea()">
                      {{ 'navbar.isCancelled.btnChange' | translate }}
                    </button>
                  </div>
                </li>
              </ng-container>
            </div>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div id="ap-language" #pecplus class="sidenav" [class.opened]="isMobileNavVisible" *ngIf="openLang">
    <div class="ms-3">
      <a class="font-14" (click)="togglelanguage($event, true)">
        <svg-icon
          src="/content/images/icons/chevron-left.svg"
          [svgStyle]="{ 'width.px': '8', 'height.px': '8', 'vertical-align': 'middle!important' }"></svg-icon>
        <span>{{ 'navbar.pecPlus.back' | translate }}</span>
      </a>
    </div>
    <div class="ms-3 mb-3 mt-4 font-16">
      <svg-icon
        src="/content/images/icons/lng-globe.svg"
        [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle' }"></svg-icon>
      <span>{{ 'navbar.selLang' | translate }}</span>
    </div>
    <ul class="ul-language">
      <ng-container *ngFor="let language of languages; let i = index">
        <li>
          <a
            class="dropdown-item ms-3 mb-2"
            [apActiveMenu]="language"
            (click)="changeLanguage(language); collapseNavbar()"
            rel="noopener noreferrer">
            <svg-icon
              src="/content/images/icons/flag-EN.svg"
              *ngIf="language === 'en'"
              [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle' }"></svg-icon>
            <svg-icon
              src="/content/images/icons/flag-ITA.svg"
              *ngIf="language === 'it'"
              [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle' }"></svg-icon>
            <svg-icon
              src="/content/images/icons/flag-ES.svg"
              *ngIf="language === 'es'"
              [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle' }"></svg-icon>

            {{ 'navbar.languagesUp.' + (language | findLanguageFromKey) | translate }}</a>
        </li>
      </ng-container>
    </ul>
  </div>
  <div id="ap-sidenav" class="sidenav" [class.opened]="isMobileNavVisible" #sidenav *ngIf="!openPecPlus && !openLang">
    <a class="close-btn" rel="noopener noreferrer" (click)="toogleMobileNav()">&times;</a>
    <div class="nav-item ms-0 mt-2 mb-3" display="dynamic">
      <div id="account-menu" *ngIf="isPecPlusVisible !== 0">
        <div>
          <ul class="ps-0">
            <li class="nav-item pointer" display="dynamic">
              <a
                class="nav-link font-14 d-flex justify-content-between me-2"
                rel="noopener noreferrer"
                (click)="togglePecPlus($event, false)">
                <span class="mx-1 text-email-mobile">{{ account?.name + ' ' + account?.lastname }}</span>
                <span *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)">
                  <span *ngIf="iconUser" class="mr-1">
                    <svg-icon
                      src="/content/images/icons/user.svg"
                      [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important' }">
                    </svg-icon>
                  </span>
                  <span *ngIf="iconUserBadge" class="mr-1">
                    <svg-icon
                      src="/content/images/icons/user.svg"
                      [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important' }">
                    </svg-icon>
                    <svg-icon
                      src="/content/images/icons/badge.svg"
                      [svgStyle]="{
                        'width.px': '12',
                        'height.px': '12',
                        'vertical-align': 'middle!important;',
                        'margin-left': '-10px',
                        'margin-top': '5px'
                      }"></svg-icon>
                  </span>
                  <span *ngIf="iconAlert" class="mr-1">
                    <svg-icon
                      src="/content/images/icons/alert-triangle.svg"
                      [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important;' }">
                    </svg-icon>
                  </span>
                  <span *ngIf="iconError" class="mr-1">
                    <svg-icon
                      src="/content/images/icons/octagon_deny1.svg"
                      [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important;' }">
                    </svg-icon>
                  </span>
                  <svg-icon
                    *ngIf="verifyAcls(acls.DOCAPOSTE_VIEW)"
                    src="/content/images/icons/chevron-right.svg"
                    [svgStyle]="{ 'width.px': '8', 'height.px': '8', 'vertical-align': 'middle!important' }">
                  </svg-icon>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="nav-item ms-3 mt-2 mb-3" *ngIf="isPecPlusVisible === 0">
        <span>{{ account?.name + ' ' + account?.lastname }}</span>
      </div>
      <hr *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)" />
    </div>

    <ap-sidebar (onOpenRoute)="toogleMobileNav()"></ap-sidebar>
    <div *ngIf="verifyAcls(acls.DOCAPOSTE_VIEW)">
      <hr />
      <div class="nav-item" *ngIf="languages && languages.length > 1">
        <!-- Lingua -->
        <ul class="ps-0">
          <li class="nav-item pointer" display="dynamic">
            <a
              class="ps-1 nav-link d-flex justify-content-between"
              rel="noopener noreferrer"
              (click)="togglelanguage($event, false)">
              <span>
                <svg-icon
                  src="/content/images/icons/lng-globe.svg"
                  [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle' }"></svg-icon>
                {{ 'navbar.language' | translate }}
              </span>

              <span class="ps-1 text-uppercase font-16">
                <svg-icon
                  src="/content/images/icons/flag-EN.svg"
                  *ngIf="currentLanguage === 'en'"
                  [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle' }"></svg-icon>
                <svg-icon
                  src="/content/images/icons/flag-ITA.svg"
                  *ngIf="currentLanguage === 'it'"
                  [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle' }"></svg-icon>
                <svg-icon
                  src="/content/images/icons/flag-ES.svg"
                  *ngIf="currentLanguage === 'es'"
                  [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle' }"></svg-icon>

                {{ 'navbar.languagesMin.' + (currentLanguage | findLanguageFromKey) | translate }}
                <svg-icon
                  src="/content/images/icons/chevron-right.svg"
                  [svgStyle]="{ 'width.px': '8', 'height.px': '8', 'vertical-align': 'middle' }"></svg-icon>
              </span>
            </a>
          </li>
        </ul>
      </div>
      <hr />
      <div class="nav-item">
        <!-- Guida -->
        <a class="ps-1 nav-link main" [href]="appConfig.navbarHelpUrl" target="_blank" rel="noopener noreferrer">
          <svg-icon
            src="/content/images/icons/question-circle.svg"
            [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'bottom' }"></svg-icon>
          <span> {{ 'navbar.guide' | translate }}</span>
        </a>
      </div>

      <div class="nav-item" *ngIf="appConfig.usabillaEnabled">
        <!-- usabillaEnabled help -->
        <hr />
        <a class="nav-link main" [href]="appConfig.assistenzaUrl" target="_blank" rel="noopener noreferrer">
          <svg-icon
            src="/content/images/icons/ico_assistenza.svg"
            [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'bottom' }"></svg-icon>
          {{ 'navbar.usabillaEnabled.help' | translate }}</a>
      </div>

      <div class="nav-item" *ngIf="appConfig.usabillaEnabled">
        <!-- usabillaEnabled send -->
        <hr />
        <!-- window.usabilla_live('click') -->
        <a class="nav-link main" (click)="sendUsabillaEvent()">
          <svg-icon
            src="/content/images/icons/ico_sms1.svg"
            [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'bottom' }"></svg-icon>
          {{ 'navbar.usabillaEnabled.sendHint' | translate }}
        </a>
      </div>
    </div>
    <div *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)">
      <hr />
      <div class="nav-item" *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)">
        <a class="ps-1 nav-link main" [href]="urlWebmail" target="_blank" rel="noopener noreferrer">
          <svg-icon
            src="/content/images/icons/ico_email.svg"
            [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'bottom' }"></svg-icon>
          <span>{{ 'navbar.webmail' | translate }} </span>
        </a>
      </div>
    </div>
    <hr />
    <div class="nav-item">
      <button class="ps-1 nav-link main exit-button" (click)="logout()">
        <svg-icon
          src="/content/images/icons/ico_esci.svg"
          [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'bottom' }"></svg-icon>
        <span classs="logout">{{ 'navbar.logout' | translate }}</span>
      </button>
    </div>
  </div>

  <div
    class="navbar-collapse collapse navbar-content-end"
    id="navbarResponsive"
    [ngbCollapse]="isNavbarCollapsed">
    <ul class="navbar-nav ml-auto">
      <div *ngIf="verifyAcls(acls.DOCAPOSTE_VIEW)">
        <li ngbDropdown class="nav-item dropdown pointer" display="dynamic" *ngIf="languages && languages.length > 1">
          <a class="nav-link dropdown-toggle" ngbDropdownToggle href="{{ hrefJavascript }}"
          id="languagesnavBarDropdown">
            <span>
              <svg-icon
                src="/content/images/icons/lng-globe.svg"
                [svgStyle]="{ 'width.px': '22', 'height.px': '22' }"></svg-icon>
              <span class="ps-1 text-uppercase fw-bold">{{
                'navbar.languages.' + (currentLanguage | findLanguageFromKey) | translate }}</span>
            </span>
          </a>
          <ul class="dropdown-menu menuLang" ngbDropdownMenu aria-labelledby="languagesnavBarDropdown">
            <ng-container *ngFor="let language of languages; let i = index">
              <li *ngIf="i > 0">
                <hr />
              </li>
              <li>
                <a class="dropdown-item" [apActiveMenu]="language" href="{{ hrefJavascript }}"
                (click)="changeLanguage(language); collapseNavbar()" rel="noopener noreferrer">
                  {{ 'navbar.languages.' + (language | findLanguageFromKey) | translate }}</a>
              </li>
            </ng-container>
          </ul>
        </li>
      </div>
      <li *ngIf="appConfig.usabillaEnabled && verifyAcls(acls.DOCAPOSTE_VIEW)" class="nav-item mr-3">
        <ng-container
          *ngTemplateOutlet="
            GuideTemplateWithUsabilla;
            context: { tagId: 'dk_help_dropdown', btnId: 'dk_dropdown_btn' }">
        </ng-container>
      </li>
      <li class="nav-item mr-3" *ngIf="!appConfig.usabillaEnabled">
        <ng-container *ngTemplateOutlet="GuideTemplateWithoutUsabilla; context: { hideDesktop: false }"></ng-container>
      </li>
      <li class="nav-item mr-3" *ngIf="appConfig.highContrastEnabled">
        <a class="nav-link" (click)="switchHighContrast(); collapseNavbar()" rel="noopener noreferrer">
          <span>
            <svg-icon
              src="/content/images/icons/high-contrast.svg"
              [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'top' }"></svg-icon>
          </span>
        </a>
      </li>
      <li ngbDropdown class="nav-item dropdown pointer" display="dynamic" routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }">
        <a class="nav-link dropdown-toggle" ngbDropdownToggle href="{{ hrefJavascript }}" id="account-menu"
         rel="noopener noreferrer">
          <span>
            <span *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)">
              <span *ngIf="iconUser" class="mr-1">
                <svg-icon
                  src="/content/images/icons/user.svg"
                  [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'middle!important' }">
                </svg-icon>
              </span>
              <span *ngIf="iconUserBadge" class="mr-1">
                <svg-icon
                  src="/content/images/icons/user.svg"
                  [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'bottom' }"></svg-icon>
                <svg-icon
                  src="/content/images/icons/badge.svg"
                  [svgStyle]="{'width.px': '12', 'height.px': '12', 'vertical-align': 'center', 'margin-left': '-10px',
                    'margin-top': '5px'}"></svg-icon>
              </span>
              <span *ngIf="iconAlert" class="mr-3">
                <div class="dot-alert-1">
                  <svg-icon
                    src="/content/images/icons/alert-triangle.svg"
                    [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'bottom' }"></svg-icon>
                </div>
                <div class="dot-alert-2"></div>
                <div class="dot-alert-3"></div>
              </span>
              <span *ngIf="iconError" class="mr-3">
                <div class="dot-1">
                  <svg-icon
                    src="/content/images/icons/octagon_deny1.svg"
                    class="openeyeimg"
                    [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'bottom' }"></svg-icon>
                </div>
                <div class="dot-2"></div>
                <div class="dot-3"></div>
              </span>
            </span>
            <strong>{{ account ? account.name + ' ' + account.lastname : 'User undefined' }}</strong>
          </span>
        </a>

        <ul class="dropdown-menu mt-2 menuUser menuUserSet dropdown-menu-user" id="menuUser" ngbDropdownMenu
        aria-labelledby="account-menu" *ngIf="account">
          <li class="mt-4">
            <div class="ms-3 text-start font-14">
              {{ 'navbar.pecPlus.pecEmail' | translate }}
            </div>
            <div class="ms-3 me-4 text-start font-18 d-flex flex-start">
              <strong class="text-email me-1 displayInline">
                {{ account ? account.name + ' ' + account.lastname : 'User undefined' }}
              </strong>
              <svg-icon
                *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW) && isPecPlusVisible === 2"
                src="/content/images/icons/badge.svg"
                [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'vertical-align': 'center' }"></svg-icon>
            </div>
          </li>
          <ng-container *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW) && isLegalPersonDeleted">
            <li class="mt-2">
              <hr />
            </li>
            <li class="mt-3">
              <div class="ps-3">
                <div class="font-14">
                  <strong class="text-email text-start" translate="navbar.isCancelled.title"
                  translate-values="{companyName: companyName}">{{ 'contacts.bannerCancelled.title' | translate }}
                </strong>
                </div>
                <div class="mt-2 font-14 text-start mr-1" translate="navbar.isCancelled.desc"
                  *ngIf="salesChannel !== 'PannelloPartner'">
                  Esegui un cambio titolare PEC
                </div>
                <div class="mt-2 font-14 text-start mr-1" translate="navbar.isCancelled.descPec"
                  *ngIf="salesChannel === 'PannelloPartner'">
                  Esegui un cambio titolare PEC
                </div>
                <div class="text-start">
                  <a href="{{ cancelledGuideUrl }}" target="_blank" rel="noopener noreferrer"
                  *ngIf="salesChannel !== 'PannelloPartner'">{{ 'navbar.isCancelled.anchorInfo' | translate }}
                  </a>
                </div>
                <div class="font-14 text-start mt-3 mr-3 d-flex justify-content-between">
                  <strong>{{ 'navbar.isCancelled.owner' | translate }}</strong>
                  <span>
                    <div class="docRequired font-12 ps-1 pe-2">
                      <div class="circleDocRequired mr-1 displayInline"></div>
                      <strong>{{ 'navbar.isCancelled.deleteCompany' | translate }} </strong>
                    </div>
                  </span>
                </div>
              </div>
              <div class="mt-2" *ngIf="salesChannel !== 'PannelloPartner'">
                <button type="button" class="btn-secondary-lined-sm ps-2" (click)="openCusermerArea()">
                  {{ 'navbar.isCancelled.btnChange' | translate }}
                </button>
              </div>
            </li>
          </ng-container>
          <ng-container
            *ngIf="
              verifyAcls(acls.TWOFA_EMAIL_VIEW) &&
              verifyAcls(acls.DOCAPOSTE_VIEW) &&
              isPecPlusVisible !== 0 &&
              !isLegalPersonDeleted">
            <li class="mt-2">
              <hr />
            </li>
            <li class="mt-3">
              <ng-container *ngIf="isPecPlusVisible === 1">
                <p class="ms-3 text-start">
                  <strong class="font-14">{{ 'navbar.pecPlus.titleDisable' | translate }}
                    <svg-icon
                      src="/content/images/icons/badge.svg"
                      [svgStyle]="{ 'width.px': '16', 'height.px': '16', 'vertical-align': 'center' }"></svg-icon>
                  </strong>
                </p>
                <p class="mt-2 ms-3 me-3 text-start font-14">{{ 'navbar.pecPlus.descDisable' | translate }}</p>
                <p class="ms-3 text-start font-14">
                  <a href="{{ urlGuide }}" target="_blank" rel="noopener noreferrer">
                    {{ 'navbar.pecPlus.question' | translate }}</a>
                </p>

                <ng-container *ngIf="recognitionStatus === 'OK'">
                  <div class="font-14 text-start ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                    <span>
                      <div class="confirm font-12 ps-1 pe-2">
                        <div class="circleConfirm mr-1 displayInline"></div>
                        <strong> {{ 'navbar.pecPlus.confirmed' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                </ng-container>
                <ng-container *ngIf="recognitionStatus === 'IdentificationPending'">
                  <div class="font-14 text-start ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                    <span>
                      <div class="notIdentified font-12 ps-1 pe-2">
                        <div class="circleNotIdentified mr-1 displayInline"></div>
                        <strong> {{ 'navbar.pecPlus.toBeConfirm' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                  <div class="identificationPending ms-3 me-3 d-flex justify-content-start">
                    <svg-icon src="/content/images/icons/time-fast.svg" class="mgr5px"></svg-icon>
                    <span>{{ 'navbar.pecPlus.identificationPending' | translate }}
                      {{ dvoExpireDate | date : 'DD/MM/YYYY' }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <button class="btn-secondary-lined-xs mt-2 ms-2 width-95" (click)="openReadDossier()">
                      {{ 'navbar.pecPlus.recognition' | translate }}
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="recognitionStatus === 'TerritorioPending'">
                  <div class="font-14 text-start ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                    <span>
                      <div class="notIdentified font-12 ps-1 pe-2">
                        <div class="circleNotIdentified mr-1 displayInline"></div>
                        <strong>{{ 'navbar.pecPlus.toBeConfirm' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                  <div class="identificationPending mt-1 ms-3 me-3 d-flex justify-content-start">
                    <svg-icon src="/content/images/icons/time-fast.svg" class="mgr5px"></svg-icon>
                    <span class="text-start"
                      >{{ 'navbar.pecPlus.identificationPending' | translate }}
                      {{ territoryExpireDate | date : 'DD/MM/YYYY' }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <button class="btn-secondary-lined-xs mt-2 ms-2 width-95" (click)="openReadDossier()">
                      {{ 'navbar.pecPlus.recognition' | translate }}
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="recognitionStatus === 'LegalValidationFailed'">
                  <div class="font-14 text-start ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                    <span>
                      <div class="docRequired font-12 ps-1 pe-2">
                        <div class="circleDocRequired mr-1 displayInline"></div>
                        <strong> {{ 'navbar.pecPlus.missingDoc' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                <!--  <div class="identificationPending mt-1 ms-3 mr-3 d-flex justify-content-start">
                    <svg-icon src="/content/images/icons/time-fast.svg" class="mgr5px"></svg-icon>
                    <span class="text-start"
                      >{{ 'navbar.pecPlus.territorioPending' | translate }}
                      {{ territoryExpireDate | date : 'DD/MM/YYYY' }}</span>
                  </div>-->
                  <div class="d-flex justify-content-between">
                    <button class="btn-secondary-lined-xs mt-2 ms-2 width-95" (click)="openReadDossier()">
                      {{ 'navbar.pecPlus.recognition' | translate }}
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="recognitionStatus === 'NotIdentified'">
                  <div class="font-14 text-start ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                    <span>
                      <div class="notIdentified font-12 ps-1 pe-2">
                        <div class="circleNotIdentified mr-1 displayInline"></div>
                        <strong>{{ 'navbar.pecPlus.toBeConfirm' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                  <div>
                    <button class="btn-secondary-lined-sm mt-2" (click)="openReadDossier()">
                      {{ 'navbar.pecPlus.recognition' | translate }}
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="recognitionStatus === 'IdentificationInProgress'">
                  <div class="font-14 text-start ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                    <span>
                      <div class="checkInProgress font-12 ps-1 pe-2">
                        <div class="circleCheckInProgress mr-1 displayInline"></div>
                        <strong> {{ 'navbar.pecPlus.checkInProgress' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                </ng-container>
                <ng-container *ngIf="recognitionStatus === 'DocumentsRequired'">
                  <div class="font-14 text-start ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.identity' | translate }}</strong>
                    <span>
                      <div class="docRequired font-12 ps-1 pe-2">
                        <div class="circleDocRequired mr-1 displayInline"></div>
                        <strong> {{ 'navbar.pecPlus.missingDoc' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                  <div>
                    <button class="btn-secondary-lined-sm mt-2" (click)="openReadDossier()">
                      {{ 'navbar.pecPlus.sendMissingDoc' | translate }}
                    </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="!isTwoFAStatus">
                  <div class="font-14 text-start mt-4 ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.2fa' | translate }}</strong>
                    <span>
                      <div class="notIdentified font-12 ps-1 pe-2">
                        <div class="circleNotIdentified mr-1 displayInline"></div>
                        <strong> {{ 'navbar.pecPlus.disabled' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                  <div>
                    <button (click)="openRoute()" class="btn-secondary-lined-sm mt-2"
                      [routerLink]="['/', currentCompany, 'security', '2stepverification']" routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"> {{ 'navbar.pecPlus.btn2fa' | translate }} </button>
                  </div>
                </ng-container>
                <ng-container *ngIf="isTwoFAStatus">
                  <div class="font-14 text-start mt-4 ms-3 me-3 d-flex justify-content-between">
                    <strong>{{ 'navbar.pecPlus.2fa' | translate }}</strong>
                    <span>
                      <div class="confirm font-12 ps-1 pe-2">
                        <div class="circleConfirm mr-1 displayInline"></div>
                        <strong> {{ 'navbar.pecPlus.enabled' | translate }} </strong>
                      </div>
                    </span>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="isPecPlusVisible === 2">
                <strong class="font-14">{{ 'navbar.pecPlus.pecplusTitle' | translate }} </strong>
                <div
                  class="mt-2 ms-3 me-3 text-start font-14"
                  [innerHTML]="'navbar.pecPlus.pecplusDesc' | translate"></div>
                <div class="ms-3 me-3 text-start font-14" [innerHTML]="'navbar.pecPlus.pecplusDesc2' | translate"></div>
                <p class="ms-3 mt-2 text-start font-14">
                  <a class="anchor question-plus" rel="noopener noreferrer" (click)="openInfoModal()">
                    {{ 'navbar.pecPlus.questionPecPlus' | translate }}</a>
                </p>
              </ng-container>
            </li>
          </ng-container>
          <li class="mt-4" *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)">
            <hr />
          </li>
          <li class="mt-3 mb-2" *ngIf="verifyAcls(acls.TWOFA_EMAIL_VIEW)">
            <a class="btn-webmail font-14" [href]="urlWebmail" rel="noopener noreferrer">
              <strong>
                {{ 'navbar.pecPlus.webmail' | translate }}
              </strong>
            </a>
          </li>
          <li class="mt-3 mb-2">
            <hr class="borderedTB" />
          </li>

          <li class="pointer mt-3 mb-3">
            <a class="btn-webmail font-14" (click)="logout()" rel="noopener noreferrer" target="blank" id="logout">
              <strong><span>{{ 'navbar.logout' | translate }}</span></strong>
            </a>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</nav>

<ng-template #GuideTemplateWithUsabilla let-tagId="tagId" let-btnId="btnId">
  <div [attr.id]="tagId" ngbDropdown class="dropdown pointer help_dropdown" display="dynamic"
   [placement]="['bottom', 'bottom-right']" style="display: flex">
    <a class="nav-link dropdown-toggle" ngbDropdownToggle href="{{ hrefJavascript }}" [attr.id]="btnId"
      style="margin-top: 2px" rel="noopener noreferrer">
      <span>
        <svg-icon
          src="/content/images/icons/question-circle.svg"
          [svgStyle]="{ 'width.px': '22', 'height.px': '22', 'vertical-align': 'top' }"></svg-icon>
      </span>
    </a>
    <ul class="dropdown-menu" ngbDropdownMenu [attr.aria-labelledby]="btnId" style="left: -90px; top: 30px !important">
      <li>
        <a class="dropdown-item" [href]="appConfig.navbarHelpUrl" target="_blank" rel="noopener noreferrer">
          {{ 'navbar.usabillaEnabled.guide' | translate }}</a>
      </li>
      <li>
        <hr />
      </li>
      <li>
        <a class="dropdown-item" [href]="appConfig.assistenzaUrl" target="_blank" rel="noopener noreferrer">
          {{ 'navbar.usabillaEnabled.help' | translate }}</a>
      </li>
      <li>
        <hr />
      </li>
      <li>
        <!-- window.usabilla_live('click') -->
        <button class="btn btn-link dropdown-item" (click)="sendUsabillaEvent()">
          {{ 'navbar.usabillaEnabled.sendHint' | translate }}
        </button>
      </li>
    </ul>
  </div>
</ng-template>

<ng-template #GuideTemplateWithoutUsabilla let-hideDesktop="hideDesktop">
  <a class="nav-link topHelp" [class.d-md-none]="hideDesktop"[href]="appConfig.navbarHelpUrl" target="_blank"
  rel="noopener noreferrer">
    <span>
      <svg-icon src="/content/images/icons/question-circle.svg" class="help"></svg-icon>
    </span>
  </a>
</ng-template>
